import { MainColor } from '../../../palette/colors';

export const getSortableItem = () => {
  return {
    defaultState: {
      backgroundColor: 'coolGrey5' satisfies MainColor as MainColor,
      color: 'navy95' satisfies MainColor as MainColor,
      actionsColor: 'navy50' satisfies MainColor as MainColor,
      icon: 'coolGrey60' satisfies MainColor as MainColor,
      divider: 'coolGrey30' satisfies MainColor as MainColor,
      secondaryColor: 'forest60' satisfies MainColor as MainColor,
    },
    hover: {
      backgroundColor: 'navy10' satisfies MainColor as MainColor,
      color: 'navy95' satisfies MainColor as MainColor,
      actionsColor: 'navy80' satisfies MainColor as MainColor,
    },
    active: {
      color: 'navy60' satisfies MainColor as MainColor,
      backgroundColor: 'coolGrey5' satisfies MainColor as MainColor,
    },
    hidden: {
      color: 'coolGrey60' satisfies MainColor as MainColor,
      backgroundColor: 'coolGrey10' satisfies MainColor as MainColor,
    },
    dragging: {
      backgroundColor: 'coolGrey5' satisfies MainColor as MainColor,
      color: 'navy60' satisfies MainColor as MainColor,
    },
  };
};

export type SortableItemTheme = ReturnType<typeof getSortableItem>;
